import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[IsBusy]',
    standalone: false
})
export class IsBusyDirective {

  @Input() autoDisableOnBusy: boolean = false;

  @Input()
  set IsBusy(val: any) {
    const el = this.hostElement.nativeElement;
    if (val) {
      this.renderer.addClass(el, 'isBusy');
      if (val === 'white') {
        this.renderer.addClass(el, 'white');
      }

      if (this.autoDisableOnBusy) {
        this.renderer.setProperty(el, 'disabled', true); // lock the host
      }
    } else {
      this.renderer.removeClass(el, 'isBusy');
      this.renderer.removeClass(el, 'white');

      if (this.autoDisableOnBusy) {
        this.renderer.removeAttribute(el, 'disabled'); // re‑enable
      }
    }
  }

  constructor(private renderer: Renderer2, private hostElement: ElementRef) {
    this.renderer.addClass(this.hostElement.nativeElement, 'isBusyContainer');


  }

}
